export default "__VITE_ASSET__eZexGckK__"